export const EU_COUNTRIES = [
    'NL',
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
]

export const AFAS_COUNTRIES = ['NL', 'DE']

export const IBAN_COUNTRIES = [
    'AL',
    'AD',
    'BE',
    'BA',
    'BG',
    'CY',
    'DK',
    'EE',
    'FO',
    'FI',
    'FR',
    'GE',
    'GI',
    'GR',
    'GL',
    'HU',
    'IE',
    'IS',
    'IL',
    'IT',
    'JO',
    'HR',
    'LV',
    'LB',
    'LI',
    'LT',
    'LU',
    'MT',
    'MU',
    'MC',
    'ME',
    'NL',
    'MK',
    'NO',
    'AT',
    'PL',
    'PT',
    'RO',
    'SM',
    'SA',
    'RS',
    'SK',
    'SI',
    'ES',
    'CZ',
    'TR',
    'TN',
    'GB',
    'AE',
    'SE',
    'CH',
]
